'use client'
import Image from 'next/image'
import React from 'react'
import styles from './styles.module.scss'

const CloseButton: React.FC<{
  image: string
  closeGameHandler: () => void
}> = ({ image, closeGameHandler }) => {
  return (
    <div className={styles.container}>
      <button className={styles.button} onClick={closeGameHandler}>
        <Image src={image} alt="close" width={14} height={14} />
      </button>
    </div>
  )
}

export default CloseButton
